import { createSelector } from "@reduxjs/toolkit";

export const selectWatchwordsCategories = (state) =>
  state.watchwords.categories;

export const selectWatchwordsCategoryTypes = createSelector(
  [selectWatchwordsCategories],
  (categories) => categories.watchwordListCategories || []
);

export const selectIsDirty = createSelector(
  [selectWatchwordsCategories],
  (categories) => Boolean(categories.isDirty)
);

export const selectIsEditing = createSelector(
  [selectWatchwordsCategories],
  (categories) => Boolean(categories.isEditing)
);

export const selectIsLoading = createSelector(
  [selectWatchwordsCategories],
  (categories) => Boolean(categories.isLoading)
);

export const selectIsLocked = createSelector(
  [selectWatchwordsCategories],
  (categories) => Boolean(categories.locked)
);

export const selectUpdatedBy = createSelector(
  [selectWatchwordsCategories],
  (categories) => categories.updatedBy
);
